module.exports = __webpack_public_path__ + "media/images/front/icons/organization-3eb982548a05920251f6d6af762533cd.png";